import type { ServerConfigBoolean } from './types';

export const isTrue = (value: ServerConfigBoolean | undefined) => (value && (value === 'true' || value === 'True' || value === true)) || false;
